import React, { useEffect } from 'react'
import { Container, Row, Col, Card, Badge } from "react-bootstrap"
import useStats from '../hooks/useStats'


function BrowseHome({ scrollToRecommended }) {
  const {stats} = useStats();


  return (
    <>
      <div className="browse-home common-padding">
        <Container>
          <div className="common-header">
            <h2>
              Browse homes in <span>Kenya</span>
            </h2>
            <p>
              The most viewed and favorited homes in the past day.
            </p>
          </div>
          <Row className="g-4">
            {stats.map((home, i) => (
              <Col key={i} xs={12} sm={6} lg={4} xl={3}>
                <Card
                  className="border-0 shadow-sm rounded-4 overflow-hidden"
                  style={{ cursor: "pointer", transition: "transform 0.3s" }}
                  onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.02)")}
                  onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                  onClick={() => {
                    if (home.title === "Recommended Homes") {
                      scrollToRecommended?.()
                    } else {
                      window.location.href = home.link
                    }
                  }}

                >
                  <Card.Body className='position-relative'>
                    <Card.Img
                      variant="top"
                      src={home.img}
                    />
                    <div className='card-info'>
                      <Badge>
                        {home.count}
                      </Badge>
                      <Card.Title>
                        {home.title}
                      </Card.Title>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </div>
    </>
  )
}
export default BrowseHome